import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Header } from '@gasbuddy/react-components';
import { Link } from 'react-router-dom';
import { getFuelBrandName, getCstoreBrandName } from '../../../lib/utils/station';
import NoClickPropagation from '../NoClickPropagation';

export default function StationDisplayName({
  brands,
  stationName,
  as,
  to,
  headerClass,
  subheaderClass,
  headerBadge,
}) {
  const hasTwoBrands = brands?.length === 2;
  const [firstBrand, secondBrand] = hasTwoBrands ? brands : [null, null];
  const isSingleBranded = firstBrand && secondBrand && firstBrand.brand_id === secondBrand.brand_id;

  const Element = useMemo(() => (
    !!to ? Link : 'span' // eslint-disable-line no-extra-boolean-cast
  ), [to]);

  const headerProps = {
    ...!!to && { to },
    style: { color: 'inherit', fontWeight: 700, textDecoration: 'inherit' },
  };

  return hasTwoBrands && !isSingleBranded ? (
    <React.Fragment>
      <Header className={headerClass} as={as} color="midnight" snug>
        <NoClickPropagation as="span">
          <Element {...headerProps}>
            {getFuelBrandName(brands) || stationName}
          </Element>
        </NoClickPropagation>
        <span>&nbsp;{headerBadge}</span>
      </Header>
      <div className={subheaderClass}>
        &nbsp;&amp;&nbsp;
        {getCstoreBrandName(brands) || stationName}
      </div>
    </React.Fragment>
  ) : (
    <Header className={headerClass} as={as} color="midnight" snug>
      <Element {...headerProps}>
        {isSingleBranded && firstBrand.name ? firstBrand.name : stationName}
      </Element>
      <span>&nbsp;{headerBadge}</span>
    </Header>
  );
}

StationDisplayName.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape({})),
  stationName: PropTypes.string.isRequired,
  as: PropTypes.string.isRequired,
  to: PropTypes.string,
  headerClass: PropTypes.string.isRequired,
  subheaderClass: PropTypes.string,
  headerBadge: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.node,
  ]),
};

StationDisplayName.defaultProps = {
  brands: [],
  subheaderClass: '',
  to: undefined,
  headerBadge: false,
};
